import { useStore, useRoute, computed } from '@nuxtjs/composition-api'

export const useFeatureFlag = (key: string) => {
  const store = useStore()
  const route = useRoute()
  const enabled = computed(
    () =>
      store.getters['settings/getFeatureFlags'][key] || route.value.query[key]
  )
  return { enabled }
}
